// eslint-disable-next-line import/no-extraneous-dependencies
import { HardBreak } from '@tiptap/extension-hard-break';
import { mergeAttributes } from '@tiptap/core';
import Mention from '@tiptap/extension-mention';

// eslint-disable-next-line import/prefer-default-export
export const HardBreakExtension = HardBreak.extend({
  addKeyboardShortcuts() {
    return {
      Enter: () => {
        const { state } = this.editor;
        const pluginState = Mention.options.suggestion.pluginKey?.getState(state);
        if (pluginState?.active) {
          return false; // Let mention handle Enter
        }
        return this.editor.commands.setHardBreak();
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ['br', mergeAttributes(HTMLAttributes)];
  },
});
